export default [{
    path: '/my-objects',
    name: 'my-objects',
    component: () => import('@/views/modules/MyObjects/index.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.object_accounting',
        active: true,
      }, ],
      action: 'read',
      resource: 'sales',
      unique_name: "my-objects"
    },
  },
  {
    path: '/objects-list',
    name: 'objects-view-only',
    component: () => import('@/views/modules/MyObjects/index.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.object_accounting',
        active: true,
      }, ],
      action: 'read',
      resource: 'sales',
      unique_name: "my-objects"
    },
  },
  {
    path: '/my-objects/object/:id',
    name: 'object-view',
    component: () => import('@/views/modules/MyObjects/view.vue'),
    meta: {
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: '',
          active: true,
        },
      ],
      action: 'read',
      resource: 'sales',
      unique_name: "my-objects"

    },
  },
  {
    path: '/my-objects/object/edit/:id',
    name: 'object-edit',
    component: () => import('@/views/modules/MyObjects/edit.vue'),
    meta: {
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.object_name',
          to: '/my-objects/object/:id',
          active: false,
        },
        {
          text: 'navbars.editing_object',
          active: true,
        },
      ],
      action: 'read',
      resource: 'sales',
      unique_name: ""

    },
  },
  {
    path: '/my-objects/object/media/edit/:id',
    name: 'object-edit-media',
    component: () => import('@/views/modules/MyObjects/mediaEdit.vue'),
    meta: {
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.editing_object',
          active: false,
          to: '/my-objects/object/:id',
        },
        {
          text: 'navbars.editing_media',
          active: true,
        },
      ],
      action: 'read',
      resource: 'sales',
      unique_name: ""
    },
  },
  {
    path: '/my-object/:id/price-history',
    name: 'object-price-history',
    component: () => import('@/views/modules/MyObjects/priceHistory.vue'),
    props: true,
    meta: {
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.object_name',
          to: '/my-objects/object/:id',
          active: false,
        },
        {
          text: 'navbars.price_history',
          active: true,
        },
      ],
      unique_name: "",
    },
  },
  {
    path: '/my-object/:id/discount-history',
    name: 'object-discount-history',
    component: () => import('@/views/modules/MyObjects/discountHistory.vue'),
    meta: {
      is_dynamic_route: true,

      breadcrumb: [{
          text: 'navbars.object_accounting',
          active: false,
          to: '/my-objects',
        },
        {
          text: 'navbars.object_name',
          to: '/my-objects/object/:id',
          active: false,
        },
        {
          text: 'navbars.discount_history',
          active: true,
        },
      ],
      unique_name: "",
    },
  },
]